export enum EduOrganizationGroupType {
  ROOT = 'R', // корневая
  GROUP = 'G', // группа
  ORGANIZATION = 'O', // организация
}
